import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { BookOpen, PlayCircle, FileText, Headphones, Sparkles } from "lucide-react";

const ICON = { audio: Headphones, video: PlayCircle, artigo: FileText, texto: FileText, pdf: FileText, exercicio: Sparkles };

function MaterialGrid({ items, testid }) {
  if (!items.length) return <p className="text-sm text-[#94A3B8] py-6 text-center">Nenhum conteúdo aqui ainda.</p>;
  return (
    <div className="grid sm:grid-cols-2 gap-4" data-testid={testid}>
      {items.map((m) => {
        const Icon = ICON[m.type] || FileText;
        return (
          <Card key={m.id} data-testid={`material-${m.id}`} className="rounded-2xl p-5 border-[#E0F2FE] card-hover">
            <div className="w-11 h-11 rounded-xl bg-[#34D399]/15 grid place-items-center mb-3"><Icon size={20} className="text-[#0F766E]" /></div>
            <Badge variant="secondary" className="text-[11px] capitalize mb-2">{m.type}</Badge>
            <h3 className="font-semibold text-[#1F3B4D]">{m.title}</h3>
            <p className="text-sm text-[#94A3B8] mt-1">{m.description}</p>
          </Card>
        );
      })}
    </div>
  );
}

export default function PatientMaterials() {
  const [forYou, setForYou] = useState([]);
  const [explore, setExplore] = useState([]);

  useEffect(() => {
    api.get("/materials?area=para_voce").then((r) => setForYou(r.data));
    api.get("/materials?area=explorar").then((r) => setExplore(r.data));
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-5 animate-fade-up">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F3B4D] flex items-center gap-2">
          <BookOpen className="text-[#0F766E]" /> Conteúdos
        </h1>
        <p className="text-sm text-[#94A3B8]">Materiais selecionados para você e biblioteca para explorar.</p>
      </div>
      <Tabs defaultValue="para_voce">
        <TabsList className="rounded-full bg-[#E0F2FE]/60">
          <TabsTrigger value="para_voce" data-testid="tab-para-voce" className="rounded-full data-[state=active]:bg-[#0F766E] data-[state=active]:text-white">Para Você</TabsTrigger>
          <TabsTrigger value="explorar" data-testid="tab-explorar" className="rounded-full data-[state=active]:bg-[#0F766E] data-[state=active]:text-white">Explorar</TabsTrigger>
        </TabsList>
        <TabsContent value="para_voce" className="mt-5"><MaterialGrid items={forYou} testid="for-you-grid" /></TabsContent>
        <TabsContent value="explorar" className="mt-5"><MaterialGrid items={explore} testid="explore-grid" /></TabsContent>
      </Tabs>
    </div>
  );
}
